import { render } from "./AddHolidayModal.vue?vue&type=template&id=ea89ac4e&scoped=true"
import script from "./AddHolidayModal.vue?vue&type=script&lang=js"
export * from "./AddHolidayModal.vue?vue&type=script&lang=js"

import "./AddHolidayModal.vue?vue&type=style&index=0&id=ea89ac4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea89ac4e"]])

export default __exports__